// extracted by mini-css-extract-plugin
export default {"root":"_2X8YFGsz","active":"hHNmYlv0"};